import { Component, Input, OnInit, signal } from '@angular/core';
import { uniqueId } from 'lodash';
import { CardTypes, GeneratedTimelineCardData, ItemPagination, ItemTypes } from 'src/app/_interfaces';
import { TimelineService } from 'src/app/_services';
import { SsrLocalstoreService } from 'src/app/_services/ssr-localstore.service';
import { TimelineScheduleEntryComponent } from '../timeline-schedule-entry/timeline-schedule-entry.component';
import { TimelineCardComponent } from '../timeline-card/timeline-card.component';
import { TimelineComponentComponent } from '../timeline-component/timeline-component.component';
import { LoadingIndicatorComponent } from '../loading-indicator/loading-indicator.component';
import { ActivatedRoute } from '@angular/router';


@Component({
    selector: 'app-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: ['./timeline.component.scss'],
    imports: [TimelineScheduleEntryComponent, TimelineCardComponent, TimelineComponentComponent, LoadingIndicatorComponent]
})
export class TimelineComponent implements OnInit {
    @Input() timeline_id!: string
    @Input() add_padding: boolean = false;
    private route_timeline_id: string | null = null
    public timeline: GeneratedTimelineCardData[] = [];
    public default_pagination: ItemPagination = {
        totalItems: 0,
        perPage: 50,
        totalPages: 0,
        currentPage: 1
    };
    public pagination: ItemPagination;
    public banner_id: string = uniqueId('banner-')
    public loading = signal(true)

    constructor(
        private timelineAPI: TimelineService,
        // private verticalUI: VerticalUIService,
        // public dialogRef: MatDialogRef<TimelineComponent>,
        // @Inject(MAT_DIALOG_DATA) public nested_timeline_id: string,
        private ssr: SsrLocalstoreService,
        private route: ActivatedRoute
    ) {
        this.pagination = this.default_pagination;
    }

    ngOnInit(): void {
        if (this.timeline_id) {
            this.getTimeline(1, this.pagination.perPage)
        } else if (this.route.snapshot.paramMap.has('timeline_id')) {
            this.timeline_id = this.route.snapshot.paramMap.get('timeline_id') as string

            this.getTimeline(1, this.pagination.perPage)
        }

        return
    }

    async getTimeline(current_page: number, take: number) {
        if (this.timeline_id || this.route_timeline_id) {
            await this.timelineAPI.getPaginatedTimelineItems(this.timeline_id, current_page, take)
                .then((data) => {
                    if (data && data.timelines) {
                        data.timelines.map((item) => {
                            if (item.card_type === 'feed_subject') item.item_type = 'component';
                        })
                        this.timeline = current_page === 1 ? (data?.timelines ?? []) : [...this.timeline, ...(data?.timelines ?? [])];
                        this.pagination = data?.pagination ?? this.default_pagination;

                        const standalone_arrays_ids = this.timeline.filter(({ item_type, card_type, context }) => (
                            item_type === 'component' && card_type === 'standalone_array' && context?.uuid
                        )).map(({ context }) => context.uuid);

                        const persistedCustomCards = JSON.parse(this.ssr.getItem('rotatingCards') || '{}');

                        if (standalone_arrays_ids?.length && Object.keys(persistedCustomCards || {}).length) {
                            Object.keys(persistedCustomCards).forEach((id) => {
                                if (!standalone_arrays_ids.includes(id)) {
                                    delete persistedCustomCards[id];
                                }
                            });
                            this.ssr.setItem('rotatingCards', JSON.stringify(persistedCustomCards));
                        }
                        this.loading.set(false)
                    }
                });
        }
    }

    async isIntersecting(status: boolean): Promise<void> {
        if (this.pagination.currentPage < 10 && this.pagination.currentPage < this.pagination.totalPages && status) {
            try {
                await this.getTimeline(this.pagination.currentPage + 1, this.pagination.perPage);
            } catch (e) { }
        }
    }

    ensureData(timeline_item: GeneratedTimelineCardData) {
        return Array.isArray(timeline_item.data) && timeline_item.data.length > 0 && !timeline_item.context.hidden ? true : false;
    }

    isCard(type: ItemTypes, card_type: CardTypes): boolean {
        return type === 'card' && card_type !== 'sponsor' ? true : false;
    }

    isComponent(type: ItemTypes, card_type: CardTypes): boolean {
        return type === 'component' && card_type !== 'sponsor' ? true : false;
    }

    isScheduleEntry(type: ItemTypes, card_type: CardTypes): boolean {
        return type === 'tennis_schedule_entry' && card_type !== 'sponsor' ? true : false;
    }

    handleBackground(item: GeneratedTimelineCardData) {
        return item?.context?.photo_url ? `url(${item.context.photo_url})` : '';
    }

    cardBorder(card_type: CardTypes) {
        if (!card_type) {
            return {};
        }

        // const types = ['standalone', 'tennis_match', 'my_followed_tennis_players', 'enhanced_articles', 'contributed_article', 'combined_social', 'broadcast_schedule', 'sponsor_placeholder', 'feed_subject', 'enhanced_article_subject', 'feed_item', 'sponsor'];

        // This types is use to check the card type that should have no borders and margin
        // Just in case a new card type is created the no borders and margin styling will not be added to the new type
        const types = ['fan_stream_post', 'trivia', 'broadcast_event_by_team', 'social_links', 'upcoming_entries', 'completed_entries', 'past_partner_entries', 'suggested_players', 'live_entries', 'entry_search', 'tennis_match_auto', 'feed_item'];

        if (card_type === 'youtube') {
            return { 'display': 'contents' }
        } else if (types.includes(card_type)) {
            return { 'border': 'none', 'margin-bottom': '0rem' };
        } else return {};
    }
}
